// Global terminology replacement for UI text only (frontend only)
// Replaces occurrences of "student" terms with "user" terms in rendered text nodes.
// Does NOT touch attributes, inputs, or API fields, or anything inside [data-keep-words]
// (text quoted as written, such as a program description from the course catalog).

const TERMINOLOGY_MAP = [
  // Order matters: longer words first
  { from: /Students\b/g, to: "Users" },
  { from: /students\b/g, to: "users" },
  { from: /Student\b/g, to: "User" },
  { from: /student\b/g, to: "user" },
  // common phrases
  { from: /student(s)? with assessments/gi, to: (m, p1) => `user${p1 || ""} with assessments` },
  { from: /No priority students/gi, to: "No priority users" },
];

function replaceInTextNode(node) {
  if (node.parentElement && node.parentElement.closest("[data-keep-words]")) return;
  let text = node.nodeValue;
  let replaced = text;
  for (const { from, to } of TERMINOLOGY_MAP) {
    replaced = replaced.replace(from, to);
  }
  if (replaced !== text) node.nodeValue = replaced;
}

function walk(node) {
  // Do not process inputs, scripts, styles
  const excluded = new Set(["SCRIPT", "STYLE", "NOSCRIPT", "TEXTAREA", "INPUT"]);
  if (excluded.has(node.nodeName)) return;
  if (node.nodeType === Node.ELEMENT_NODE && node.hasAttribute("data-keep-words")) return;

  if (node.nodeType === Node.TEXT_NODE) {
    replaceInTextNode(node);
  } else {
    for (let child = node.firstChild; child; child = child.nextSibling) {
      walk(child);
    }
  }
}

function initObserver() {
  // Initial pass
  walk(document.body);

  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType === Node.TEXT_NODE) {
          replaceInTextNode(node);
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          walk(node);
        }
      }
      if (m.type === "characterData" && m.target.nodeType === Node.TEXT_NODE) {
        replaceInTextNode(m.target);
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
  });
}

export function initTerminologyReplacement() {
  if (typeof window === "undefined" || typeof document === "undefined") return;
  if (document.readyState === "complete" || document.readyState === "interactive") {
    initObserver();
  } else {
    document.addEventListener("DOMContentLoaded", initObserver, { once: true });
  }
}
